// extracted by mini-css-extract-plugin
export default {"closePopupButton":"TemplatesWizard_closePopupButton__99RHj","popupWrapper":"TemplatesWizard_popupWrapper__o44to"};